import userService from '../../services/user';

import {
  togglePopup,
} from '../mutations_type';

import {
  getEmailName,
} from '../../help/index';

function setStorage(key, value) {
  if (window.localStorage) localStorage.setItem(key, value);
}

function removeStorage(key) {
  if (window.localStorage) localStorage.removeItem(key);
}

const types = {
  USER_STATUS_RESET: 'userService/user_status_reset',  

  USER_LOGIN_OUT: 'userService/user_login_out',  
  USER_LOGIN_IN: 'userService/user_login_in',
  USER_LOGIN_IN_ERROR: 'userService/user_login_in_error',
  
  USER_FORGETPASSWORD_STATUS: 'userService/user_forgetpassword_status',

  USER_RESETPASSWORD_STATUS: 'userService/user_resetpassword_status',
  USER_RESETPASSWORD_MESSAGE: 'userService/user_resetpassword_message',

  USER_UPDATEPASSWORD_STATUS: 'userService/user_updatepassword_status',
  USER_UPDATEPASSWORD_MESSAGE: 'userService/user_updatepassword_message',
  
  USER_CHECK_ACCOUNT_STATUS: 'userService/user_check_account_status',
  USER_CHECK_ACCOUNT_MESSAGE: 'userService/user_check_account_message',
};

const state = {
  resetPasswordStatus: '',
  resetPasswordMsg: '',

  updatePasswordStatus: '',
  updatePasswordMsg: '',

  forgetPasswordStatus: '',

  checkUserAccountStatus: '',
  checkUserAccountMsg: '',
  
  userLoginStatus: false,
  userLoginError: false,
};

const getters = {
  getUserLoginStatus: s => s.userLoginStatus,
  getUserLoginError: s => s.userLoginError,
  
  getForgetpasswordStatus: s => s.forgetPasswordStatus,

  getUpdatepasswordStatus: s => s.updatePasswordStatus,
  getUpdatepasswordMsg: s => s.updatePasswordMsg,

  getResetpasswordStatus: s => s.resetPasswordStatus,
  getResetpasswordMsg: s => s.resetPasswordMsg,

  getCheckUserAccountStatus: s => s.checkUserAccountStatus,
  getCheckUserAccountMsg: s => s.checkUserAccountMsg,
};

const actions = {

  resetUserStatus({ commit }) {
    commit(types.USER_STATUS_RESET);
  },

  actionUserLoginIn({ commit }) {
    commit(types.USER_LOGIN_IN);
  },
  actionUserLoginOut({ commit }) {
    commit(types.USER_LOGIN_OUT);
  },

  actionLoginIn({ commit }, userData) {
    
    const { router } = userData;

    userService.signInUser(userData)
    .then((res) => { 

      const {
        id,
        email,
        type,
        parties,
        token_info: tokenInfo,
        low_activity: lowActivity,
      } = res.data.data;

      // 長時間未登入判斷
      if (lowActivity) {

        router.push('/check_account_status');

      } else {

        const {
          access_token,
        } = tokenInfo;
  
        setStorage('access_token', access_token);
        setStorage('expire_time', new Date().getTime());
        setStorage('username', getEmailName(email));
        setStorage('id', id);
        setStorage('type', type);
        setStorage('parties', JSON.stringify(parties));

        commit(types.USER_LOGIN_IN);

        router.push('/');
      }

      commit(togglePopup);

    })
    .catch(() => commit(types.USER_LOGIN_IN_ERROR));
  },
  
  actionForgetPassword({ commit }, viewData) {

    const { 
      router, 
      email,
    } = viewData;

    userService.forgetPasswordUser(email)
    .then(() => {
      
      commit(types.USER_LOGIN_OUT);
      commit(types.USER_FORGETPASSWORD_STATUS, 'success');

      removeStorage('expire_time');
      removeStorage('access_token');
      removeStorage('username');
      removeStorage('type');
      removeStorage('id');
      removeStorage('parties');

      router.push('/');
    })
    .catch(() => {
      commit(types.USER_FORGETPASSWORD_STATUS, 'fail');
      console.log('系統錯誤');
    });
  },

  actionResetPassword({ commit }, viewData) {

    const {
      newpw,
      confirmpw,
      token,
      router,
    } = viewData;

    userService.resetPasswordUser(newpw, confirmpw, token)
    .then(() => {
      commit(types.USER_LOGIN_OUT);
      commit(types.USER_RESETPASSWORD_STATUS, 'success');

      removeStorage('expire_time');
      removeStorage('access_token');
      removeStorage('username');
      removeStorage('id');
      removeStorage('type');
      removeStorage('parties');

      router.push('/');
    })
    .catch((error) => {
      const data = error.response.data;

      const {
        message,
      } = data;

      commit(types.USER_RESETPASSWORD_STATUS, 'fail');
      commit(types.USER_RESETPASSWORD_MESSAGE, message);

    });
  },

  actionUpdatePassword({ commit }, viewData) {

    const {
      oldpw,
      confirmpw,
      newpw,
      token,
    } = viewData;

    userService.updatePasswordUser(oldpw, confirmpw, newpw, token)
    .then(() => {
      commit(types.USER_LOGIN_OUT);
      commit(types.USER_UPDATEPASSWORD_STATUS, 'success');
    })
    .catch((error) => {
      const data = error.response.data;

      const {
        message,
      } = data;

      commit(types.USER_UPDATEPASSWORD_STATUS, 'fail');
      commit(types.USER_UPDATEPASSWORD_MESSAGE, message);
    });
  },

  actionCheckAccount({ commit }, viewData) {

    const {
      router,
      verificationCode,
    } = viewData;

    userService.checkAccount(verificationCode)
    .then((res) => {
      
      commit(types.USER_CHECK_ACCOUNT_STATUS, 'success');

      const {
        id,
        email,
        type,
        parties,
        token_info: tokenInfo,
      } = res.data.data;

      const {
        access_token,
      } = tokenInfo;

      setStorage('access_token', access_token);
      setStorage('expire_time', new Date().getTime());
      setStorage('username', getEmailName(email));
      setStorage('id', id);
      setStorage('type', type);
      setStorage('parties', JSON.stringify(parties));

      commit(types.USER_LOGIN_IN);

      router.push('/');
    
    })
    .catch((error) => {
      const data = error.response.data;

      const {
        message,
      } = data;

      commit(types.USER_CHECK_ACCOUNT_STATUS, 'fail');
      commit(types.USER_CHECK_ACCOUNT_MESSAGE, message);
    });
  },

};

// mutations
const mutations = {
  [types.USER_STATUS_RESET](s) {
    s.userLoginError = false;
    s.forgetPasswordStatus = '';

    s.updatePasswordStatus = '';
    s.updatePasswordMsg = '';

    s.checkUserAccountStatus = '';
    s.checkUserAccountMsg = '';
  },
  [types.USER_LOGIN_OUT](s) {

    removeStorage('expire_time');
    removeStorage('access_token');
    removeStorage('username');
    removeStorage('id');
    removeStorage('type');
    removeStorage('parties');

    s.userLoginStatus = false;
  },
  [types.USER_LOGIN_IN](s) {
    s.userLoginStatus = true;
  },
  [types.USER_LOGIN_IN_ERROR](s) {
    s.userLoginError = true;
  },
  [types.USER_FORGETPASSWORD_STATUS](s, result) {
    s.forgetPasswordStatus = result;
  },
  [types.USER_RESETPASSWORD_STATUS](s, result) {
    s.resetPasswordStatus = result;
  },
  [types.USER_RESETPASSWORD_MESSAGE](s, msg) {
    s.resetPasswordMsg = msg;
  },
  [types.USER_UPDATEPASSWORD_STATUS](s, result) {
    s.updatePasswordStatus = result;
  },
  [types.USER_UPDATEPASSWORD_MESSAGE](s, msg) {
    s.updatePasswordMsg = msg;
  },
  [types.USER_CHECK_ACCOUNT_STATUS](s, result) {
    s.checkUserAccountStatus = result;
  },
  [types.USER_CHECK_ACCOUNT_MESSAGE](s, msg) {
    s.checkUserAccountMsg = msg;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js